import React, { useState } from 'react';
import axios from 'axios';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function WishlistButton({ productId, initialInWishlist = false, size = 'default' }) {
  const [inWishlist, setInWishlist] = useState(initialInWishlist);
  const [loading, setLoading] = useState(false);

  const toggleWishlist = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Please log in to add to wishlist');
      return;
    }

    setLoading(true);
    try {
      if (inWishlist) {
        await axios.delete(`${API_URL}/api/wishlist/${productId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setInWishlist(false);
        toast.success('Removed from wishlist');
      } else {
        await axios.post(
          `${API_URL}/api/wishlist/add`,
          { product_id: productId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setInWishlist(true);
        toast.success('Added to wishlist');
      }
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to update wishlist';
      if (message === 'Already in wishlist') {
        setInWishlist(true);
      } else {
        toast.error(message);
      }
    } finally {
      setLoading(false);
    }
  };

  if (size === 'icon') {
    return (
      <button
        onClick={toggleWishlist}
        disabled={loading}
        className={`p-2 rounded-full transition-all ${
          inWishlist
            ? 'bg-red-500 text-white'
            : 'bg-black/50 text-white hover:bg-red-500/80'
        } ${loading ? 'opacity-50' : ''}`}
      >
        <Heart className={`w-5 h-5 ${inWishlist ? 'fill-current' : ''}`} />
      </button>
    );
  }

  return (
    <Button
      onClick={toggleWishlist}
      disabled={loading}
      variant={inWishlist ? 'default' : 'outline'}
      className={inWishlist ? 'bg-red-500 hover:bg-red-600' : 'border-white/20'}
    >
      <Heart className={`w-4 h-4 mr-2 ${inWishlist ? 'fill-current' : ''}`} />
      {inWishlist ? 'In Wishlist' : 'Add to Wishlist'}
    </Button>
  );
}

export default WishlistButton;
